import { render } from "./AlertComponent.vue?vue&type=template&id=76c9cfc6&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import "./AlertComponent.vue?vue&type=style&index=0&id=76c9cfc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c9cfc6"]])

export default __exports__